import { render, staticRenderFns } from "./MyBuy.vue?vue&type=template&id=0d4f84b6&scoped=true&"
import script from "./MyBuy.vue?vue&type=script&lang=js&"
export * from "./MyBuy.vue?vue&type=script&lang=js&"
import style0 from "./MyBuy.vue?vue&type=style&index=0&id=0d4f84b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f84b6",
  null
  
)

export default component.exports